/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../common';
import Component from 'flarum/common/Component';
import Stream from 'flarum/common/utils/Stream';
import Button from 'flarum/common/components/Button';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.banner_form.device_tabs`;

const RESPONSIVE_KEYS = ['default', 'tablet', 'phone'];

export default class DeviceTabs extends Component {
	oninit(vnode) {
		super.oninit(vnode);

		this.active = new Stream(RESPONSIVE_KEYS[0]);
	}

	view() {
		const { inputs } = this.attrs;

		return (
			<div className="DeviceTabs">
				<div className="DeviceTabs__labels">
					{RESPONSIVE_KEYS.map((device) => (
						<Button className={`Button Button--flat ${device} ${this.active() === device ? 'active' : ''}`} onclick={() => this.active(device)}>
							{t(`${prfx}.${device}`)}
						</Button>
					))}
				</div>
				{RESPONSIVE_KEYS.map((device) => (
					<div className={`DeviceTabs__tabs__tab ${device} ${this.active() === device ? 'active' : ''}`}>
						{this.active() === device ? inputs(this.active()) : null}
					</div>
				))}
			</div>
		);
	}
}
